import React from 'react';

const BASE_URL = 'http://assets.staza.io/icons';

const Icon = ({ name, size }) => {
  return <img src={`${BASE_URL}/${name}.svg`} alt={name} width={size} height={size}/>;
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Common/Icon/index.js